import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../../components/Configurer";
import ProfileImage from "../../components/partials/ProfileImage";
import ItemModal from "../../modals/ItemModal";
import HttpServices from "../../utils/Http.services";
import { checkTextTranslation, checkTranslation, getObject, pathMaker, setObject, translate } from "../../utils/useful";
import DataGrid from "../../components/DataGrid";
import Pagination from "../../components/Pagination";
import OptionsListModal from "../../modals/OptionsListModal";
import RemoveConfirmationModal from "../../modals/RemoveConfirmationModal";
import FormViewer from "../../components/FormViewer";
import ButtonAnimated from "../buttons/ButtonAnimated";
import CustomLoader from "../CustomLoader";
import Modal from "../Modal";
import store from "../../stores/storeConfig";


class SettingsView extends React.Component {


    openEditModal = (prop, index) => {
        // console.log(prop)
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })

        // console.log("remove")
    }

    state = {
        data: [],
        actions: {
            add: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: this.openEditModal },
            edit: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: this.openRemoveModal }
        },
        currentPage: 0,
        limit: 10
    }


    componentDidMount() {
        // console.log("componentDidMount TP")
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (this.props.page !== prevProps.page) {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }
    }


    init() {

        if (this.props.page) {



            this.setState({ data: [] }, () => {
                this.fetchData(true)
            })

            this.setHeader()
        }


    }

    setHeader = () => {

        // console.log(this.props.page)

        if (this.props.setHeader) {

            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                'title': this.props.page?.title,
                'subtitle': this.props.page?.subtitle,
                // topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.changePage('')

            })


        }
    }



    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.savePage}
                    title={translate("Update")}
                    icon='/assets/icons/arrow-right-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }


    fetchData = (getCount) => {


        this.setState({ isLoadingData: true })
        let body = {}
        let page = this.props.page
        let baseUrl = this.props.baseUrl

        let path = this.props.windowData?.path


        // body.page = page.key
        // body.limit = this.state.limit
        // body.skip = this.state.currentPage

        if (page.filter) {
            body = { ...body, ...page.filter }
            // console.log(body)
        }

        // if (this.state.totalCount == null || getCount) {
        //     body.getCount = true
        // }
        

        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                if (baseValue) {

                    if (baseValue.startsWith('*url') && page?.key) {
                        baseValue = `[${baseValue.replace('*url.', '')}]`
                        let urlKey = page.key.split('/')
                        let urlIndex = urlKey.indexOf(baseValue)

                        if (urlIndex != -1) {
                            let finalValue = path[baseUrl.length + urlIndex]
                            if (finalValue) {
                                body[key] = finalValue
                            }
                        }

                    } else if (this.props.variables) {
                        body[key] = this.props.variables[baseValue]
                    }
                }
            }
        }

        // console.log(this.props.variables)

        // console.log(this.props.applet)
        // console.log('page.fetchUrl', page.fetchUrl)
        // console.log('body', body)
        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            console.log(fetchResult)
            this.setState({ initData: fetchResult.info })

            if (fetchResult.count) {
                this.setState({ totalCount: fetchResult.count })
            }
        })
    }


    fetchUpdate = () => {
        console.log("fetchUpdate")
        this.setState({ isLoadingUpdate: true })
        let page = this.props.page
        let data = this.form.getForm()
        // console.log(data)
        if (data) {
            if (page.postBody) {
                data = { ...data, ...page.postBody }
            }
            for (const [key, value] of Object.entries(data)) {
                if (/\{\{(.*?)\}\}/.test(value)) {

                    let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                    if (baseValue) {

                        if (this.props.variables) {
                            data[key] = this.props.variables[baseValue]
                        }
                    }
                }
            }
            HttpServices.request(this.props.page.editUrl, data, (fetchResult, fetchError) => {
                this.setState({ isLoadingUpdate: false })
                console.log('fetchError', fetchError)
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: fetchError.message })
                    return
                }
                // console.log('this.props.page', this.props.page)
                // let applet = this.props.applet
                // console.log('beforeApplet', applet)
                this.props.page.headers.map((element) => {
                    // let newApplet = setObject(applet, element.key, fetchResult.info[element.key])
                    let object = getObject(fetchResult.info, element.key)
                    this.setData(`applet.${element.key}`, object, 'Applet')
                })
                if (this.props.page.configType == 'frame' && this.props.frameUpdateActions) {
                    this.props.frameUpdateActions(fetchResult.info, 'edit')
                }
                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.updateSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })


            })
        }
    }

    itemAdded = (newItem) => {
        let data = this.state.data
        data.splice(0, 0, newItem)
        // console.log(newItem)
        // console.log(data)
        this.setState(data)
    }

    itemEdited = (editedItem) => {
        // console.log(editedItem)
        let data = this.state.data
        this.state.data.forEach((element, index) => {
            let id = element.id ?? element._id
            let currentId = this.state.currentItem.id ?? this.state.currentItem._id
            if (id === currentId) {
                // console.log(id)
                data[index] = Object.assign({}, editedItem)
            }
        });
        this.setState({ data }, () => {
            // console.log(editedItem)
            // console.log(data)
            // this.TableViewer.forceUpdateData()
        })
    }

    // updateData = (data) => {
    //     this.setState(data)
    // }


    // openAddNew = () => {
    //     if (this.props.page?.addNew) {
    //         this.props.history.push(pathMaker(this.props.page?.addNew + '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key)))
    //     } else {
    //         this.openEditModal()
    //     }
    // }


    // changePage = (index) => {
    //     this.setState({ currentPage: index }, () => {
    //         this.fetchData()
    //     })
    // }


    // openOptions = (prop, index) => {
    //     // console.log(prop)
    //     let options
    //     if (prop.status == -1) {
    //         options = [
    //             { name: 'View', icon: '/images/eye.svg', function: this.openView },
    //             { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
    //             { name: 'Connect', icon: '/images/settings.svg', function: this.fetchConnect },
    //             { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
    //         ]
    //     } else {
    //         options = [
    //             { name: 'View', icon: '/images/eye.svg', function: this.openView },
    //             { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
    //             { name: 'Disconnect', icon: '/images/settings.svg', function: this.fetchDisconnect },

    //         ]
    //     }

    //     this.setState({ options, currentItem: prop, currentIndex: index }, () => {
    //         this.optionsModal.modal.showModal()
    //     })

    // }


    // openRemoveModal = () => {
    //     this.removeModal.modal.showModal()
    // }


    // openEdit = () => {
    //     this.itemModal.modal.showModal()
    // }
    // openView = () => {
    //     let id = this.state.currentItem._id
    //     this.props.history.push(pathMaker('/' + this.props.page.viewAddress + '/' + id))
    // }


    // fetchRemove = () => {
    //     this.setState({ isLoadingRemove: true })
    //     let id = this.state.currentItem._id
    //     HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingRemove: false })

    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
    //             return
    //         }
    //         let data = this.state.data

    //         data.forEach((element, index) => {
    //             if (element._id == id) {
    //                 data.splice(index, 1)
    //             }
    //         });

    //         this.setState({ data })
    //         this.removeModal.modal.hideModal()
    //         this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })


    //     })

    // }


    // fetchDisconnect = () => {
    //     this.fetchStatus(-1)
    // }

    // fetchConnect = () => {
    //     this.fetchStatus(1)
    // }



    // fetchStatus = (newStatus) => {
    //     this.setState({ isLoadingRemove: true })
    //     let id = this.state.currentItem._id
    //     HttpServices.request('changeThingStatus', { "id": id, status: newStatus }, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingRemove: false })

    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
    //             return
    //         }
    //         // console.log(this.state.currentIndex)
    //         let data = this.state.data

    //         data.forEach((element, index) => {
    //             if (element._id == id) {
    //                 data[index].status = newStatus
    //             }
    //         });

    //         this.setState({ data })
    //         // this.removeModal.modal.hideModal()
    //         this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.actionSuccesfully', description: '{{lang}}info.dataActionSuccessfully' })

    //     })
    // }
    setData = (key, value, reference, cb) => {
        if (reference == 'SettingsView') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }
    changePage = (page) => {
        this.props.changePage(page)
        // console.log("changePage")
    }

    remove = () => {
        let page = this.props.page
        if (page.configType == 'applet') {
            this.removeApplet()
        }

        if (page.configType == 'frame') {
            this.removeFrame()
        }
    }



    removeFrame = () => {

        let data = this.form.getForm()
        HttpServices.request('removeFrame', { _id: data._id }, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: fetchError.message })
                return
            }
            this.removeModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
            store.dispatch(actions.removeConnection([data._id]))
            if (this.props.frameUpdateActions) {
                this.props.frameUpdateActions(data._id)
            }
            this.props.closeWindow()

        })
    }


    removeApplet = () => {

        let data = this.form.getForm()
        HttpServices.request('removeApplet', { _id: data._id }, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: fetchError.message })
                return
            }
            this.removeModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
            store.dispatch(actions.removeConnection([data._id]))
            this.props.closeWindow()

        })
    }

    render() {
        // console.log( this.props.page?.actions)
        let page = this.props.page
        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        // variables.changePage = this.changePage

        let background = `linear-gradient(90deg, ${this.props.colors?.primaryColor}, ${this.props.colors?.secondaryColor})`


        return (


            <div className="h-100" style={{ backgroundColor: '#f0f0f0', overflow: 'auto' }}>

                <div className=" " >
                    <div className="row m-0">




                        <div className=" mb-5 mt-2 w-100 p-2 flexc flex-column">

                            <div className="p-3 px-4 " style={{ width: '100%', maxWidth: 600, backgroundColor: '#fff', borderRadius: 20 }}>



                                {this.state.isLoadingData && (
                                    <div className="flexcc flex-column py-5">
                                        <CustomLoader color={"#007aff"} isLoading={true} width={30} height={30} />
                                        <p className="text-smaller mt-1 color-gray-3">{translate("is Loading ...")}</p>
                                    </div>
                                )}

                                {!this.state.isLoadingData && (
                                    <>
                                        <div className="px-2 mb-4" >
                                            <div className="p-0" style={{ borderRadius: 0 }}>

                                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>

                                                    <div className="flexc mt-2 px-2">

                                                        {/* <ProfileImage width={54} borderRadius={50} notif={0} border={'2px solid #eee'} className={'mrd-3'} data={{ image: this.props.page?.image }} /> */}

                                                        <div>
                                                            <p className="text-semibig text-semibold m-0 " style={{ color: '#0d172a' }}>{checkTranslation(this.props.page?.title)}</p>
                                                            <p className="text-small m-0" style={{ color: '#89a' }} >{checkTranslation(this.props.page?.description)}</p>
                                                        </div>
                                                    </div>



                                                </div>
                                            </div>

                                        </div>


                                        <FormViewer ref={el => this.form = el} headers={this.props.page?.headers} initData={this.state.initData} errors={this.state.errors} inputClass={'modern-input'} variables={variables} />
                                        <div className="px-3 mb-4 flexcb">
                                            <div className="flexc">
                                                <ButtonAnimated
                                                    iconwidth='28px'
                                                    isLoading={this.state.isLoadingUpdate}
                                                    onClick={this.fetchUpdate}
                                                    title='{{lang}}Update'
                                                    icon='/assets/icons/save.svg'
                                                    invert={!this.props.colors?.iconInvert}
                                                    bg={background}
                                                    textColor={this.props.colors?.textColor}
                                                />

                                                <div className="px-2">
                                                    <ButtonAnimated
                                                        iconwidth='28px'
                                                        isLoading={this.state.isLoadingUpdate}
                                                        onClick={() => this.changePage('')}
                                                        title='{{lang}}Cancel'
                                                        // icon='/assets/icons/save.svg'
                                                        invert={true}
                                                        bg={'linear-gradient(to right, #eee, #eee)'}
                                                        textColor={'#777'}
                                                    />
                                                </div>


                                            </div>

                                            {page?.configType == 'applet' && (
                                                <ButtonAnimated
                                                    iconwidth='28px'
                                                    // isLoading={this.state.isLoadingRemove}
                                                    onClick={() => { this.removeModal.showModal() }}
                                                    title='{{lang}}Remove Applet'
                                                    // icon='/assets/icons/save.svg'
                                                    invert={true}
                                                    icon='/assets/icons/useful/trash.png'
                                                    bg={'linear-gradient(to right, rgb(217, 0, 0), rgb(217, 0, 0))'}
                                                    textColor={'#fff'}
                                                />
                                            )}


                                            {page?.configType == 'frame' && (
                                                <ButtonAnimated
                                                    iconwidth='28px'
                                                    // isLoading={this.state.isLoadingRemove}
                                                    onClick={() => { this.removeModal.showModal() }}
                                                    title='{{lang}}Remove'
                                                    invert={true}
                                                    // icon='/assets/icons/save.svg'
                                                    icon='/assets/icons/useful/trash.png'
                                                    bg={'linear-gradient(to right,rgb(217, 0, 0),rgb(217, 0, 0))'}
                                                    textColor={'#fff'}
                                                />
                                            )}

                                        </div>
                                    </>)}


                            </div>

                            {/* {this.props.page?.headers?.map((prop, index) => {
                                if (prop.type == 'section') {
                                    return (
                                        <div>

                                        </div>
                                    )
                                } else {
                                    return (
                                        <div className="flexcb" key={index} style={{ width: '100%', maxWidth: 300 }}>
                                            <p>{checkTranslation(prop.information.label)}</p>
                                            <img src="/images/nexts.png" height="14px" />
                                        </div>
                                    )
                                }
                            })} */}
                        </div>


                    </div>


                    {/* <ItemModal
                        ref={el => this.itemModal = el}
                        page={this.props.page}
                        headers={this.props.page?.headers}
                        initData={this.state.currentItem}
                        itemAdded={this.itemAdded}
                        itemEdited={this.itemEdited}
                    />




                    <OptionsListModal ref={el => this.optionsModal = el}
                        options={this.state.options}
                    /> */}

                    {/* <RemoveConfirmationModal ref={el => this.removeModal = el} confirmed={this.fetchRemove} /> */}




                </div>
                <Modal maxWidth={400} ref={(el) => this.removeModal = el}  >
                    <div className="w-100  " style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                        <div className="p-4">
                            <p className="text-normal weight-600 pb-3" style={{}}>{translate("Are you sure you want to remove?")}</p>
                            <p className="text-small weight-500 main-c7" style={{}}>{translate('drives.rethink-your-decision')}</p>
                            <div className="flexc w-100 pt-4" style={{ justifyContent: 'flex-end' }}>
                                <div className="flexc mrd-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => { this.removeModal.hideModal(); }}
                                        title={translate('Cancel')}
                                        textColor={'rgb(119, 119, 119)'}
                                        bg={'#eee'}
                                    />
                                </div>
                                <div className="flexc mld-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        // isLoading={this.state.isLoading}
                                        onClick={() => { this.remove() }}
                                        title={translate('Remove')}
                                        invert={true}
                                        icon='/assets/icons/useful/trash.png'
                                        textColor={'#fff'}
                                        bg={`linear-gradient(90deg, rgb(217, 0, 0), rgb(217, 0, 0))`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingsView);
